export const GT_PARTS = {
    front_bumper: 1001,
    bonnet: 1002,
    windscreen: 1003,
    left_headlamp: 1004,
    right_headlamp: 1005,
    grille: 1006,
    front_plate: 1007,
    front_emblem: 1008,
    front_bumper_moulding: 1009,
    front_bumper_left_moulding: 1010,
    front_bumper_right_moulding: 1011,
    front_left_light_cap: 1012,
    front_right_light_cap: 1013,
    front_left_fog_light: 1014,
    front_right_fog_light: 1015,
    left_inferior_grille: 1017,
    inferior_grille: 1018,
    right_inferior_grille: 1019,
    front_sensor: 1020,
    front_bumper_right_arch_moulding: 1023,
    front_bumper_left_arch_moulding: 1024,
    upper_center_front_bumper: 1025,
    lower_center_front_bumper: 1026,
    upper_left_front_bumper: 1027,
    upper_right_front_bumper: 1028,
    front_right_towing_cap: 1029,
    front_left_towing_cap: 1030,
    front_spoiler_moulding: 1031,
    front_spoiler: 1032,
    headlamp_right_washer_cap: 1033,
    headlamp_left_washer_cap: 1034,
    front_left_door: 2001,
    front_left_wing: 2002,
    front_left_window: 2003,
    front_left_rim: 2004,
    front_left_tyre: 2005,
    left_mirror: 2006,
    front_left_door_handle: 2007,
    front_left_door_moulding: 2008,
    front_left_wing_arch_moulding: 2009,
    front_left_door_arch_moulding: 2010,
    front_left_fuel_flap: 2012,
    rear_left_door: 3001,
    rear_left_wing: 3002,
    rear_left_window: 3003,
    rear_left_rim: 3004,
    rear_left_tyre: 3005,
    left_sill_panel: 3006,
    rear_left_door_handle: 3007,
    rear_left_door_moulding: 3008,
    rear_left_wing_arch_moulding: 3009,
    rear_left_door_arch_moulding: 3010,
    rear_left_fuel_flap: 3012,
    rear_bumper: 4001,
    trunk: 4002,
    rear_screen: 4003,
    left_tail_lamp: 4004,
    right_tail_lamp: 4005,
    rear_spoiler: 4006,
    rear_plate: 4007,
    rear_emblem: 4008,
    rear_bumper_moulding: 4009,
    rear_bumper_left_moulding: 4010,
    rear_bumper_right_moulding: 4011,
    rear_left_light_cap: 4012,
    rear_right_light_cap: 4013,
    rear_left_fog_light: 4014,
    rear_right_fog_light: 4015,
    rear_fog_light: 4016,
    left_exhaust: 4021,
    right_exhaust: 4022,
    rear_bumper_right_arch_moulding: 4023,
    rear_bumper_left_arch_moulding: 4024,
    upper_center_rear_bumper: 4025,
    lower_center_rear_bumper: 4026,
    upper_left_rear_bumper: 4027,
    upper_right_rear_bumper: 4028,
    rear_right_towing_cap: 4029,
    rear_left_towing_cap: 4030,
    rear_spoiler_moulding: 4031,
    rear_right_door: 5001,
    rear_right_wing: 5002,
    rear_right_window: 5003,
    rear_right_rim: 5004,
    rear_right_tyre: 5005,
    right_sill_panel: 5006,
    rear_right_door_handle: 5007,
    rear_right_door_moulding: 5008,
    rear_right_wing_arch_moulding: 5009,
    rear_right_door_arch_moulding: 5010,
    rear_right_fuel_flap: 5012,
    front_right_wing_arch_moulding: 6009,
    front_right_door_arch_moulding: 6010,
    front_right_fuel_flap: 6012,
    front_right_door: 6001,
    front_right_wing: 6002,
    front_right_window: 6003,
    front_right_rim: 6004,
    front_right_tyre: 6005,
    right_mirror: 6006,
    front_right_door_handle: 6007,
    front_right_door_moulding: 6008,
    roof: 7001
};
export class ThirdPartyInfoEstimation {
    provider;
    error;
    url;
    reportUrl;
    mismatchedParts;
    constructor(estimation) {
        this.provider = estimation.provider;
        this.error = estimation.error;
        this.url = estimation?.url;
        this.reportUrl = estimation?.reportUrl;
        this.mismatchedParts = estimation?.mismatchedParts ?? [];
    }
}
